import { createContext, useContext } from "react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const DESIGN_W = 1920;
export const DESIGN_H = 1080;

const isDev = process.env.NODE_ENV === 'development';
export const devLog = (...args) => { if (isDev) console.log(...args); };
export const devError = (...args) => { if (isDev) console.error(...args); };
export const devDebug = (...args) => { if (isDev) console.debug(...args); };

export const resolveUrl = (url) => {
  if (!url) return "";
  if (url.startsWith('data:')) return url;
  if (url.startsWith('http://') || url.startsWith('https://')) {
    const uploadsMatch = url.match(/\/api\/uploads\/.+$/);
    if (uploadsMatch) return `${BACKEND_URL}${uploadsMatch[0]}`;
    const legacyMatch = url.match(/(\/uploads\/.+)$/);
    if (legacyMatch) return `${BACKEND_URL}/api${legacyMatch[1]}`;
    return url;
  }
  if (url.startsWith('/uploads/') && !url.startsWith('/api/uploads/'))
    return `${BACKEND_URL}/api${url}`;
  if (url.startsWith('/api/'))
    return `${BACKEND_URL}${url}`;
  return `${BACKEND_URL}${url}`;
};

// Context exposing the Visualizer controller (state + computed values) to
// extracted child overlays without prop-drilling.
export const VisualizerContext = createContext(null);
export const useViz = () => useContext(VisualizerContext);
